import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AmountPipe } from '../../../payments/payment/pipes';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: 'equine-ui-nx-subscription-receipt-list-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule,
    AmountPipe,
    MatTableModule,
    MatButtonModule
  ],

  templateUrl: './subscription-receipt-list-dialog.component.html',
  styleUrl: './subscription-receipt-list-dialog.component.scss',
})
export class SubscriptionReceiptListDialogComponent implements OnInit {

  subscription: any;
  displayedColumns = ['id', 'date', 'amount', 'receipt'];


  constructor(
    public dialogRef: MatDialogRef<SubscriptionReceiptListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {subscription: any},
  ) {}

  ngOnInit() {
    this.subscription = this.data.subscription;
    console.log(this.subscription)
  }

  openSimpleReceiptDialog(payment: any) {
    this.dialogRef.close(payment.serviceId);
  }
 
}
